import { useMergedStyles } from 'hooks/useMergedStyles';
import { FC } from 'react';
import { Styles } from 'types/styles';
import colors from 'styles/_colors.module.scss';
import styles from './SpinnerCircular.module.scss';

type Props = {
  newStyles?: Styles;
};

const SpinnerCircular: FC<Props> = ({ newStyles = {} }) => {
  const mergedStyles = useMergedStyles(styles, newStyles);

  return (
    <div className={mergedStyles['spinner-circular']}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
      >
        <g fill={colors['--black']} clipPath="url(#clip0_6980_9876)">
          <path
            d="M8 0a8 8 0 100 16A8 8 0 008 0zm0 14.4A6.4 6.4 0 118 1.6a6.4 6.4 0 010 12.8z"
            opacity="0.5"
          />
          <path d="M14.4 8H16a7.999 7.999 0 00-8-8v1.6A6.4 6.4 0 0114.4 8z" />
        </g>
        <defs>
          <clipPath id="clip0_6980_9876">
            <path fill={colors['--white']} d="M0 0H16V16H0z" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default SpinnerCircular;
